var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_play-button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "46_My-playlist",
    transform: "translate(-301, -409)",
    fill: "#BFE82D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_play-button",
    transform: "translate(301, 409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.58853125,0 0,3.588875 0,8 C0,12.411125 3.58853125,16 8,16 C12.4114688,16 16,12.411125 16,8 C16,3.588875 12.4114687,0 8,0 Z M11.1803437,8.28028125 L6.5136875,11.2802812 C6.459,11.31575 6.39584375,11.3333437 6.33334375,11.3333437 C6.27865625,11.3333437 6.2233125,11.3196562 6.17384375,11.2926562 C6.06640625,11.2340625 6,11.1220625 6,11 L6,5 C6,4.8779375 6.06640625,4.7659375 6.17384375,4.70734375 C6.2793125,4.64940625 6.41146875,4.65296875 6.5136875,4.71971875 L11.1803437,7.71971875 C11.2754062,7.78090625 11.3333437,7.88671875 11.3333437,8 C11.3333437,8.11328125 11.2754062,8.2190625 11.1803437,8.28028125 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayButton);
export default __webpack_public_path__ + "static/media/ic_play-button.8776b757a324365ea373d02d452068c4.svg";
export { ForwardRef as ReactComponent };